export { default } from './VerticalTabs.js';
